export default __webpack_public_path__ + "static/media/del.0a274e17.svg";